export const ratingCoverageTabs = {
  issuers: 'issuers',
  research: 'research',
};
